/* HEllO — keeping the brand's small L's, everywhere.

   The theme uppercases a lot of type. text-transform happens at render, so a
   correctly typed "HEllO" in the admin still appears as "HELLO" inside any
   heading, button or label that forces caps. This walks the rendered page and
   wraps each occurrence in .wc-brand, which opts that one word out of the
   case being forced on it.

   WHAT IT MATCHES: the word on its own, in any case. At HEllO the word is
   always the mark — "Say HEllO in person", "THE HEllO STORY", "HEllO PLAY
   STUDIO", "Say HEllO to wrist fashion". An earlier version of this file
   protected a sentence-case "Hello" on the theory that it might be ordinary
   English; that was wrong for this brand and left exactly those headings
   reading HELLO.

   WHAT IT LEAVES ALONE: anything that is part of a longer token rather than a
   word — helloedc.com, hello@helloedc.com, hello-indus-khadi, /hello/. Those
   are addresses and handles, not display copy, and rewriting them would break
   what they point at. */

(function () {
  'use strict';

  if (window.__wcBrandInit) return;
  window.__wcBrandInit = true;

  var BRAND = 'HEllO';

  var RE = /\bhello\b/gi;

  /* The word is the brand wherever it is read as a word. The only exclusions
     are the neighbours that mean it is really part of an address or a handle:
     an @ either side, a dot before a domain, or a slash, dash or underscore
     joining it to something else. */
  function isBrand(text, start, end) {
    var before = text.charAt(start - 1);
    if (before === '@' || before === '/' || before === '.' || before === '-') return false;

    var after = text.slice(end);
    if (after.charAt(0) === '@') return false;
    if (/^\.[A-Za-z]/.test(after)) return false;        /* hello.com */
    if (/^[-_/][A-Za-z0-9]/.test(after)) return false;  /* hello-edc, hello/story */

    return true;
  }

  var SKIP = {
    SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1,
    NOSCRIPT: 1, TEMPLATE: 1, CODE: 1, PRE: 1, SVG: 1, TITLE: 1
  };

  function skippable(el) {
    while (el && el !== document.body) {
      if (SKIP[el.nodeName]) return true;
      if (el.classList && el.classList.contains('wc-brand')) return true;
      if (el.isContentEditable) return true;
      el = el.parentNode;
    }
    return false;
  }

  function wrap(node) {
    var text = node.nodeValue;
    RE.lastIndex = 0;

    var frag = null;
    var at = 0;
    var m;

    while ((m = RE.exec(text)) !== null) {
      if (!isBrand(text, m.index, m.index + m[0].length)) continue;

      if (!frag) frag = document.createDocumentFragment();
      if (m.index > at) {
        frag.appendChild(document.createTextNode(text.slice(at, m.index)));
      }

      var span = document.createElement('span');
      span.className = 'wc-brand';
      span.textContent = BRAND;
      frag.appendChild(span);

      at = m.index + m[0].length;
    }

    if (!frag) return false;

    if (at < text.length) frag.appendChild(document.createTextNode(text.slice(at)));
    node.parentNode.replaceChild(frag, node);
    return true;
  }

  function sweep(root) {
    if (!root || !root.nodeType) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue) return NodeFilter.FILTER_REJECT;
        RE.lastIndex = 0;
        if (!RE.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (skippable(n.parentNode)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    /* Collected first: replacing a node while walking invalidates the walker. */
    var hits = [];
    var n;
    while ((n = walker.nextNode())) hits.push(n);
    hits.forEach(wrap);
  }

  var pending = null;
  var busy = false;

  function run() {
    if (busy) return;
    busy = true;
    try { sweep(document.body); } finally {
      /* The wrapping is itself a mutation; let it settle before listening. */
      setTimeout(function () { busy = false; }, 0);
    }
  }

  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (busy || pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
